
export function getUrlParameter(key) {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.has(key) ? searchParams.get(key) : '';
}

export function setUrlParameter(name, values) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(name, values.toString());
    history.replaceState(null, null, '?'+searchParams.toString());
}

export function fetchData(action, data, callback, method = 'POST') {
    const request = new XMLHttpRequest();
    request.open(method, '/wp-admin/admin-ajax.php', true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    request.onload = function() {
        if (this.status >= 200 && this.status < 400 && this.response) {
            callback(JSON.parse(this.response));
        }
    }

    if ( ! data ) {
        request.send('action=' + action);
    } else {
        const params = Object.keys(data).map(function (k) {
            return `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`;
        }).join('&');
        request.send('action=' + action + '&' + params);
    }
}

export function setSessionCookie(cookieName, cookieValue) {
    document.cookie = cookieName+"="+cookieValue + ";expires=0;path=/";
}

export function loadCSS(href) {
    return new Promise(function(resolve, reject) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = resolve;
        link.onerror = reject;
        document.head.appendChild(link);
    });
}

export function loadJS(src) {
    return new Promise(function(resolve, reject) {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });
}